/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IAuthorization } from '../../models/Authorization/IAuthorization';

export const getAuthDetailsAction = (assignedPermissions: IAuthorization) => {
  return {
    type: 'GET_AUTH_DETAILS',
    assignedPermissions: assignedPermissions
  };
};
export const getAuthPolicyDetailsAction = (resourcePermissions: any) => {
  return {
    type: 'GET_AUTH_POLICY_DETAILS',
    resourcePermissions: resourcePermissions
  };
};
